import React from 'react';
import { BookOpen, Rocket, Star } from 'lucide-react';

const plans = [
  {
    icon: BookOpen,
    title: 'Plano UP',
    subtitle: 'Ensino Fundamental',
    features: [
      'Método Personalizado: Adaptação da forma de estudo para cada aluno',
      'Rotina de Estudos e Organização: Planejamento para estudos em casa e escola',
      'Habilidades Essenciais: Foco em caligrafia, ortografia e leitura',
      'Comunicação e Confiança: Desenvolvimento de oratória e redação',
      'Superação de Bloqueios: Apoio emocional para vencer traumas acadêmicos',
      'Aprendizado Dinâmico: Uso de atividades sensoriais e lúdicas',
    ],
  },
  {
    icon: Rocket,
    title: 'Plano Avança',
    subtitle: '1º e 2º anos',
    features: [
      'Desenvolvimento de Repertório: Ampliação do conhecimento sociocultural',
      'Técnicas de Escrita: Aprimoramento da estrutura textual',
      'Preparação Progressiva: Foco em vestibulares e ENEM',
      'Acompanhamento Personalizado: Feedback detalhado das produções',
      'Estratégias de Estudo: Organização e planejamento eficiente',
      'Suporte Contínuo: Orientação para dúvidas e revisões',
    ],
  },
  {
    icon: Star,
    title: 'Mentoria PDTE Individual',
    subtitle: '3º ano e Pré-Vestibular',
    features: [
      'Planejamento Completo: Organização de cronogramas para todas as áreas',
      'Metas Personalizadas: Estratégias focadas para vestibulares e ENEM',
      'Preparação Intensiva: Simulados direcionados e práticas de redação',
      'Flexibilidade Total: Acompanhamento ajustado à rotina do aluno',
      'Apoio Emocional: Suporte contínuo para lidar com a pressão do vestibular',
    ],
  },
];

const Plans = () => {
  return (
    <section id="plans" className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Mentorias e Planos
          </h2>
          <p className="text-xl text-primary/80 max-w-3xl mx-auto">
            Escolha o plano ideal para o seu momento e comece sua jornada de transformação na redação.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan) => (
            <div
              key={plan.title}
              className="relative bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow"
            >
              <div className="text-center mb-8">
                <plan.icon className="h-12 w-12 mx-auto mb-4 text-primary" />
                <h3 className="text-2xl font-bold text-primary mb-2">{plan.title}</h3>
                <p className="text-primary/70">{plan.subtitle}</p>
              </div>
              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-start text-primary/80">
                    <span className="mr-2 text-accent mt-1.5">•</span>
                    <span className="flex-1">{feature}</span>
                  </li>
                ))}
              </ul>
              <div className="text-center">
                <a
                  href="#contact"
                  className="inline-block w-full px-6 py-3 rounded-full font-semibold transition-colors bg-accent text-white hover:bg-accent-dark"
                >
                  Quero Saber Mais
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Plans;